import { FC } from 'react';
import { Flex, Text, Skeleton } from '@chakra-ui/react';
import { ArcadeChest } from '../../assets/ArcadeChest';
import { formatNumber } from '../../helpers/numbers';
export interface CbChestBalanceProps {
  color?: string;
  chestBalance: number;
  fontWeight?: string;
  isPending: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
}
export const CbChestBalance: FC<CbChestBalanceProps> = ({
  color = 'text.secondary',
  chestBalance,
  fontWeight = 'semibold',
  isPending,
  size = 'md'
}) => {
  const tokenSize = size === 'sm' ? ['16px', '20px'] : ['20px', '24px'];
  return <Flex alignItems="center" data-sentry-element="Flex" data-sentry-component="CbChestBalance" data-sentry-source-file="CbChestBalance.tsx">
      <ArcadeChest marginRight={1} width={tokenSize} height={tokenSize} data-sentry-element="ArcadeChest" data-sentry-source-file="CbChestBalance.tsx" />
      {isPending ? <Skeleton data-testid="skeleton" height={6} width={7} /> : <Text color={color} fontSize={size} fontWeight={fontWeight}>
          {formatNumber(chestBalance)}
        </Text>}
    </Flex>;
};